import React from 'react';
import CardSiteBox from '../CardHomeBox/index';
import Search from '../../../img/procurar.svg';
import Mask from '../../../img/mask.svg';
import Engine from '../../../img/engine.svg';
import { Title } from './style';

const SiteBox = () => (
	<div style={{ backgroundColor: '#fff', padding: '0 0' }}>
		<Title>Por que é necessário <br /> ter um site?</Title>
		<div className="row" style={{ marginBottom: '1px', padding: '0 34px' }}>
			<div className="col-md-12 col-lg-4 col-xl-4">
				<CardSiteBox
					icon={Search}
					altIcon=""
					titleIcon="Logo"
					title="Mais"
					titleRed="Presença Digital"
					text="Um excelente meio para garantir sua presença digital
                    e ter seu estoque online."
				/>
			</div>
			<div className="col-md-12 col-lg-4 col-xl-4">
				<CardSiteBox
					icon={Mask}
					altIcon=""
					titleIcon="Alvo"
					title="Mais"
					titleRed="Disponibilidade"
					text="Sua loja aberta 24 horas por dia, 7 dias por semana,
                    sem perder negócio."
				/>
			</div>
			<div className="col-md-12 col-lg-4 col-xl-4">
				<CardSiteBox
					icon={Engine}
					altIcon=""
					titleIcon="Landing Page"
					title="Mais"
					titleRed="Negócios"
					text="Multiplique suas oportunidades de novos negócios,
                    aumente sua rede de clientes."
				/>
			</div>
		</div>
	</div>
);

export default SiteBox;
